import { t } from "i18next"
import FeedbackPopup from "./FeedbackPopup/FeedbackPopup"
import React, { useEffect, useState } from "react"
import GrievanceStatusPopup from "./GrievanceStatusPopup/GrievanceStatusPopup"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../Helper/Context/context"
import { GrievanceStatusFeedbackPatchAPI, GrievanceStatusGetAPI } from "../../../../Helper/Redux/CitizenRegistrationSlice/GrievanceStatusSlice"
import moment from "moment"
import TrackPopup from "./TrackPopup/TrackPopup"
import { useSearchParams } from "react-router-dom"

export const Resolved = ({Language}) => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID, IndicatorGrievanceAreaID } = userDetails

    const [ShowConfirmationPopup, setShowConfirmationPopup] = useState(false)
    const [ShowViewPopup, setShowViewPopup] = useState(false)
    const [FeedBackShowPopup, setFeedBackShowPopup] = React.useState(false)
    const [GrievanceStatusShowPopup, setGrievanceStatusShowPopup] = React.useState(false)
    const [TrackShowPopup, setTrackShowPopup] = React.useState(false)

    const [ShowModal, setShowModal] = useState(false)
    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState('')
    const [ReceivedDate, setReceivedDate] = useState('')
    const [IsSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [From, setFrom] = useState(1)

    const [isopen, setIsOpen] = useState(false);

    const [searchparams] = useSearchParams()
    const screenname = searchparams.get('screenname')
    const Flag = searchparams.get('Flag')
    

    const [Feedback, setFeedback] = useState(Flag == 'ViewFeedBackPopUp' ? ModalData.RowData.feedback : '')

    const [ModalData, setModalData] = useState({
        Flag: '',
        RowData: ''
    })
    // const [Language, setLanguage] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: sessionStorage.getItem('LanguageChange')
    // })

    // const [Language, setLanguage] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: ''
    // })

    // useEffect(() => {
    //     setLanguage({
    //         ...Language,
    //         DDL: [],
    //         ID: 0,
    //         Label: sessionStorage.getItem('LanguageChange'),
    //     })
    // }, [])


    const handleShowView = (rowData, t_GrievanceRegistrationID, Heading) => {
        // console.log("dgdfg",t_GrievanceRegistrationID)
        setGrievanceStatusShowPopup(!GrievanceStatusShowPopup)
        setModalData({
            Flag: '',
            RowData: rowData ? rowData : '',
            t_GrievanceRegistrationID: t_GrievanceRegistrationID,
            Heading: Heading
        })
    }

    const handleFeedbackConfirmation = (rowData) => {
        setFeedBackShowPopup(!FeedBackShowPopup)
        setModalData({
            Flag: '',
            RowData: rowData ? rowData : '',
            // heading: heading

        })
    }
    const handleTrackDetails = (rowData, t_GrievanceRegistrationID) => {
        setTrackShowPopup(!TrackShowPopup)
        setModalData({
            Flag: '',
            RowData: rowData ? rowData : '',
            t_GrievanceRegistrationID: t_GrievanceRegistrationID
            // heading: heading

        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    useEffect(() => {
        const data = {
            GrievanceDate: "",
            M_IndicatorGrievanceTypeID: 0,
            M_StatusID: 0,
            Flag: "GrievanceStatus",
            // Language: "English",
            M_UserID: UserID,
            FromTop: From,
            ToTop: '9999',
            token: token,
            Language: Language.Label,
        }
        { Language.Label != '' && dispatch(GrievanceStatusGetAPI({ data })) }

    }, [IsSearch, IsPost, From, Language.Label])

    const { TableData, isLoading } = useSelector(state => state.GrievanceStatusGetData)

    // console.log('first',Language.Label)

    const handleFeedback = () => {
        // console.log('Feedback',feedback)
        const data = {
            T_GrievanceRegistrationID: ModalData.RowData.t_GrievanceRegistrationID,
            Feedback: Feedback,
            token: token,
            M_UserID: UserID,
            handleFeedbackConfirmation: handleFeedbackConfirmation,
            handleIsPost: handleIsPost,

        }
        dispatch(GrievanceStatusFeedbackPatchAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.GrievanceStatusFeedbackPatchData)

    const AllData = TableData && TableData.length > 0 ? TableData : []
    const PendingData = AllData.filter(i => i.m_StatusID != 7)
    const ResolvedData = AllData.filter(i => i.m_StatusID == 7)

    // one card, used by both the pending and the resolved list
    const StatusCard = ({ i, Heading, ActionLabel, ActionIcon, onAction }) => (
        <div className="am-status-card">
            <div className="am-status-card-top">
                <span className={`am-chip Status-${i.m_StatusID}`}>
                    <i className="fa-solid fa-star"></i>
                    {i?.statusName}
                </span>
                {i.t_GrievanceRegistrationID &&
                    <span className="am-ref">#{i.t_GrievanceRegistrationID}</span>
                }
            </div>

            <div
                className="am-status-card-body"
                title="संपूर्ण तपशील पहा"
                onClick={() => handleShowView(i, i.t_GrievanceRegistrationID, Heading)}
            >
                <div className="am-status-row">
                    <small>{t('DirectorDashboard.GrievanceDate')}</small>
                    <b>{i.transactionDate ? moment(i.transactionDate).format('DD-MM-YYYY') : '-'}</b>
                </div>
                <div className="am-status-row">
                    <small>{t('DirectorDashboard.GrievanceType')}</small>
                    <b>{i.m_IndicatorGrievanceType ? i.m_IndicatorGrievanceType : '-'}</b>
                </div>
            </div>

            <div className="am-status-card-foot">
                <button type="button" className="am-btn am-btn--soft am-btn--sm" onClick={onAction}>
                    <i className={ActionIcon}></i> {ActionLabel}
                </button>
                <button
                    type="button"
                    className="am-btn am-btn--ghost am-btn--sm"
                    onClick={() => handleShowView(i, i.t_GrievanceRegistrationID, Heading)}
                >
                    <i className="fa-solid fa-eye"></i>
                </button>
            </div>
        </div>
    )

    return (
        <>
            {/* pending */}
            <div className="am-section-bar am-rise">
                <span className="am-section-bar-ico"><i className="fa-solid fa-hourglass-half"></i></span>
                <div>
                    <h2>{t('DirectorDashboard.PendingGrievance')}</h2>
                    <p>कार्यवाही सुरू असलेल्या तक्रारी</p>
                </div>
                <span className="am-count">{PendingData.length}</span>
            </div>

            {
                isLoading ?
                    <div className="am-empty am-rise">
                        <i className="fa-solid fa-circle-notch fa-spin"></i>
                        <span>माहिती घेत आहे...</span>
                    </div>
                    :
                    PendingData.length > 0 ?
                        <div className="am-status-grid am-rise am-rise-2">
                            {
                                PendingData.map((i, index) => (
                                    <StatusCard
                                        key={i.t_GrievanceRegistrationID ? i.t_GrievanceRegistrationID : index}
                                        i={i}
                                        Heading="Pending"
                                        ActionLabel={t('GrievanceStatus.Track')}
                                        ActionIcon="fa-solid fa-route"
                                        onAction={() => handleTrackDetails(i, i.t_GrievanceRegistrationID)}
                                    />
                                ))
                            }
                        </div>
                        :
                        <div className="am-empty am-rise am-rise-2">
                            <i className="fa-solid fa-circle-check"></i>
                            <span>
                                <b>प्रलंबित तक्रार नाही</b>
                                <span>सध्या कार्यवाही सुरू असलेली कोणतीही तक्रार नाही.</span>
                            </span>
                        </div>
            }

            {/* resolved */}
            <div className="am-section-bar am-section-bar--ok am-rise am-rise-3">
                <span className="am-section-bar-ico"><i className="fa-solid fa-circle-check"></i></span>
                <div>
                    <h2>{t('DirectorDashboard.ReslovedGrievance')}</h2>
                    <p>निराकरण झालेल्या तक्रारींवर अभिप्राय नोंदवा</p>
                </div>
                <span className="am-count">{ResolvedData.length}</span>
            </div>

            {
                isLoading ?
                    <div className="am-empty am-rise am-rise-3">
                        <i className="fa-solid fa-circle-notch fa-spin"></i>
                        <span>माहिती घेत आहे...</span>
                    </div>
                    :
                    ResolvedData.length > 0 ?
                        <div className="am-status-grid am-rise am-rise-4">
                            {
                                ResolvedData.map((i, index) => (
                                    <StatusCard
                                        key={i.t_GrievanceRegistrationID ? i.t_GrievanceRegistrationID : index}
                                        i={i}
                                        Heading="Resolved"
                                        ActionLabel={t('GrievanceStatus.Feedback')}
                                        ActionIcon="fa-solid fa-comment-dots"
                                        onAction={() => handleFeedbackConfirmation(i)}
                                    />
                                ))
                            }
                        </div>
                        :
                        <div className="am-empty am-rise am-rise-4">
                            <i className="fa-regular fa-folder-open"></i>
                            <span>
                                <b>निराकरण झालेली तक्रार नाही</b>
                                <span>तक्रारीचे निराकरण झाल्यावर ती येथे दिसेल.</span>
                            </span>
                        </div>
            }

            {
                FeedBackShowPopup ?
                    <FeedbackPopup
                        handleFeedbackConfirmation={handleFeedbackConfirmation}
                        setFeedBackShowPopup={setFeedBackShowPopup}
                        handleFeedback={handleFeedback}
                        Feedback={Feedback}
                        setFeedback={setFeedback}
                        Flag='ViewFeedBackPopUp'
                        ModalData={ModalData}
                        ScreenName1='GrivancesStatus'

                    />
                    : ''
            }

            {
                TrackShowPopup ?
                    <TrackPopup
                        handleTrackDetails={handleTrackDetails}
                        setTrackShowPopup={setTrackShowPopup}
                        ModalData={ModalData}
                    // ImagePopUpData={ImagePopUpData}
                    />
                    : ''
            }

            {
                GrievanceStatusShowPopup ?
                    <GrievanceStatusPopup
                        // Heading={Heading}
                        setGrievanceStatusShowPopup={setGrievanceStatusShowPopup}
                        Title={`${ModalData.Heading}`}
                        handleShowView={handleShowView}
                        ModalData={ModalData}
                    />
                    : ''
            }



        </>


    )
}